import { AdminInput, AdminModal } from '@project/components';
import React from 'react';
import { useTranslations } from '../../utils/hooks';

export const SSOProviderModal = ({ provider, onUpdateProvider, ...rest }) => {
  const [t] = useTranslations();

  return (
    <AdminModal title={t('CompanySettingsSSOTab.modal.title')} {...rest}>
      <div>
        <AdminInput
          value={provider?.certificate}
          label={t('CompanySettingsSSOTab.certificate.label')}
          type="textarea"
          onChange={e => onUpdateProvider({ ...provider, certificate: e.target.value })}
        />
        <AdminInput
          value={provider?.entryPointUrl}
          label={t('CompanySettingsSSOTab.entryPointUrl.label')}
          type="text"
          onChange={e => onUpdateProvider({ ...provider, entryPointUrl: e.target.value })}
        />
        <AdminInput
          value={provider?.issuerUrl}
          label={t('CompanySettingsSSOTab.issuerUrl.label')}
          type="text"
          onChange={e => onUpdateProvider({ ...provider, issuerUrl: e.target.value })}
        />
      </div>
    </AdminModal>
  );
};
